import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CatalogsService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  //Catalogo de roles

  getAllRol(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.get(`${this.apiUrl}/roles`, { headers });
  }

  createRol(rol: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.post(`${this.apiUrl}/roles`, rol, { headers });
  }

  editRol(rol: any, rolId: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.put(`${this.apiUrl}/roles/${rolId}`, rol, { headers });
  }

  deleteRol(rolId: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.delete(`${this.apiUrl}/roles/${rolId}`, { headers });
  }

  //Catalogo de usuarios

  getAllUser(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.get(`${this.apiUrl}/users`, { headers });
  }

  createUser(user: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.post(`${this.apiUrl}/users`, user, { headers });
  }

  editUser(user: any, UserId: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.put(`${this.apiUrl}/users/${UserId}`, user, { headers });
  }

  deleteUser(user: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.delete(`${this.apiUrl}/users/${user}`, { headers });
  }

  //Catalogo de clientes

  getAllClient(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.get(`${this.apiUrl}/clients`, { headers });
  }

  createClient(client: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.post(`${this.apiUrl}/clients`, client, { headers });
  }

  editClient(client: any, ClientrId: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.put(`${this.apiUrl}/clients/${ClientrId}`, client, { headers });
  }

  deleteClient(client: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.delete(`${this.apiUrl}/clients/${client}`, { headers });
  }


  //Catalogo de areas

  getAllArea(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.get(`${this.apiUrl}/dirsfact`, { headers });
  }

  createArea(area: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.post(`${this.apiUrl}/dirsfact`, area, { headers });
  }

  editArea(area: any, areaId: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.put(`${this.apiUrl}/dirsfact/${areaId}`, area, { headers });
  }

  deleteArea(area: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.delete(`${this.apiUrl}/dirsfact/${area}`, { headers });
  }

  //Catalogo de proyectos

  getAllProjects(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.get(`${this.apiUrl}/projects`, { headers });
  }


  createProjet(projet: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.post(`${this.apiUrl}/projects`, projet, { headers });
  }

  editProjet(projet: any, projetId: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.put(`${this.apiUrl}/projects/${projetId}`, projet, { headers });
  }

  deleteProjet(projet: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.delete(`${this.apiUrl}/projects/${projet}`, { headers });
  }

  //catalago de años
  getYears(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.get(`${this.apiUrl}/years`, { headers });
  }

  createYears(token: string, anio: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });
    const body = { Año: anio };  
    return this.http.post(`${this.apiUrl}/years`, body, { headers });
  }
  
  editYears(token: string, anio: any): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });
    const body = { Año: anio.seleccion };
    return this.http.put(`${this.apiUrl}/years/${anio.id}`, body, { headers });
  }
  
  deleteYears(token: string, id: any): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });
    return this.http.delete(`${this.apiUrl}/years/${id}`, { headers });
  }

}
